<!--{{loginForm.value|json}}-->
<form [formGroup]="loginForm" novalidate>
  <tc-form-group>
    <tc-input [placeholder]="'Login'" formControlName="pseudo"></tc-input>
  </tc-form-group>

  <tc-form-group>
    <tc-input [placeholder]="'Password'" [type]="'password'" formControlName="password"
              readonly
              onfocus="this.removeAttribute('readonly');"></tc-input>
  </tc-form-group>

  <tc-form-group *ngIf="false">
    <tc-switcher [value]="true">Remember me</tc-switcher>
  </tc-form-group>

  <div class="actions justify-content-between">
    <button tc-button [tcBgColor]="settings.loginBtnColor" [beforeIcon]="'icofont-login'"
            [disabled]="loginForm.invalid"
            (click)="_loginEvent()">
      Login
    </button>
  </div>
</form>

